__webpack_require__.p = "/react-crypto-app/";